import api from './api';

const ruleQ = (ruleId) => (ruleId ? `?ruleId=${ruleId}` : '');

const routingService = {
    list:    (ppId, ruleId)           => api.get(`/paymentporter/${ppId}/routing${ruleQ(ruleId)}`),
    getById: (ppId, routingId)        => api.get(`/paymentporter/${ppId}/routing/${routingId}`),
    create:  (ppId, data, ruleId)     => api.post(`/paymentporter/${ppId}/routing${ruleQ(ruleId)}`, data),
    update:  (ppId, routingId, data)  => api.put(`/paymentporter/${ppId}/routing/${routingId}`, data),
    remove:  (ppId, routingId)        => api.delete(`/paymentporter/${ppId}/routing/${routingId}`),
};

export default routingService;
